import { profileUrl } from '../api/tmdb'
import { IconTrophy } from './icons'

const PLACEHOLDER = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='185' height='278' viewBox='0 0 185 278'%3E%3Crect fill='%23333' width='185' height='278'/%3E%3Ccircle fill='%23555' cx='92' cy='100' r='40'/%3E%3Cellipse fill='%23555' cx='92' cy='220' rx='60' ry='50'/%3E%3C/svg%3E"

const fmt = (s) => {
  const m = Math.floor(s / 60).toString().padStart(2, '0')
  const ss = (s % 60).toString().padStart(2, '0')
  return `${m}:${ss}`
}

export default function H2HWaiting({ challenge, myRole, myResult }) {
  const opponentRole = myRole === 'p1' ? 'p2' : 'p1'
  const opponentResult = myRole === 'p1' ? challenge?.player2Result : challenge?.player1Result
  const opponentUser = myRole === 'p1' ? challenge?.player2 : challenge?.player1
  const goal = challenge?.goalActor

  return (
    <div className="h2h-waiting">
      <div className="h2h-waiting__content">
        <div className="h2h-waiting__pulse" aria-hidden="true" />

        <p className="h2h-waiting__title">You finished! <IconTrophy size={18} style={{ verticalAlign: 'middle' }} /></p>

        {myResult && (
          <div className="h2h-waiting__my-score">
            <span className="h2h-waiting__score-val">{myResult.moves}</span>
            <span className="h2h-waiting__score-label">hops · {fmt(myResult.timeSeconds || 0)}</span>
          </div>
        )}

        {!opponentResult ? (
          <>
            <p className="h2h-waiting__opp-label">
              Waiting for <strong>{opponentUser?.username || 'your opponent'}</strong>…
            </p>
            <div className="h2h-waiting__dots">
              <span /><span /><span />
            </div>
          </>
        ) : (
          <p className="h2h-waiting__opp-label">Opponent finished — loading results…</p>
        )}

        {goal && (
          <div className="h2h-waiting__goal">
            <img
              src={goal.profile_path ? profileUrl(goal.profile_path, 'w185') : PLACEHOLDER}
              alt={goal.name}
              onError={(e) => { e.target.src = PLACEHOLDER }}
            />
            <span>{goal.name}</span>
          </div>
        )}
      </div>
    </div>
  )
}
